export default __webpack_public_path__ + "static/FoundersGrotesk-Light-ad6eb535db98c2114de3912835c6800a.otf";